import { ILastState } from '../../state/types';
import { makeManagedSourceSetFetch } from './_shared/fetchMakers';
import { normalizeSingleEntity } from './_shared/normalizers';
import { makeRoutesUrl } from './_shared/urlMakers';

export const fetchRoutes = makeManagedSourceSetFetch<ILastState[]>(
    makeRoutesUrl,
    normalizeSingleEntity
);
